import { Component, EventEmitter, OnInit } from '@angular/core';

import { ReviewGroupService } from '../../service/review-group.service';
import { ReturnMessageModel } from '../../model/return-message.model';
import { MessageComponent } from '../message/message.component';
import { ReviewGroup } from '../../model/review-group.model';

@Component({
  styles: [''],
  selector: 'app-review-modal',
  templateUrl: './review-modal.component.html',
})
export class ReviewModalComponent implements OnInit {
  selected = new EventEmitter<ReviewGroup>();

  display = false;
  lastEvent: any;

  groupList: ReviewGroup[] = [];
  group: ReviewGroup = new ReviewGroup({});
  
  constructor(private service: ReviewGroupService) {}

  ngOnInit() {}

  getGroups = () => this.service.getAll().subscribe(({rows}) => this.groupList = rows as ReviewGroup[]);

  lazy(e) {
    this.lastEvent = e;
    // this.getGroups();
  }

  onShow(group: ReviewGroup) {
    if(group) this.group = group;
    // else this.getGroups();

    this.display = true;
  }

  onHide() {
    this.onNew();
    this.display = false;
  }

  onSelect(e) {
    this.group = e.data as ReviewGroup;
  }

  onConfirm() {    
    this.selected.emit(this.group);
    this.onHide();
  }

  onNew() {
    this.group = new ReviewGroup({
      last_review_calc_id: this.group.last_review_calc_id
    });
    this.clearGroupValues();
  }
  

  clearGroupValues() {
    this.group.review_total = 0;
    this.group.reviewed = 0;
    this.group.balance = 0;
  }

  onSave() {
    (this.group.id ? this.service.put(this.group) : this.service.post(this.group))
    .subscribe((res: MessageComponent) => {
      if (res.error) console.error(res)
      else this.onNew();

      this.lazy(this.lastEvent);
    });
  }

  onDelete() {
    this.service.delete(this.group.id).subscribe(
      (r: ReturnMessageModel) => {
        this.lazy(this.lastEvent);
        this.onNew();
    });
  }

  validate(): boolean {
    return !!this.group.description;
  }
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/component/review-modal/review-modal.component.ts